import React, { forwardRef, useState, useRef, useEffect } from 'react';
import ButtonStyled from './bundle.esm2.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';
import LoadingSVG from '../../assets/images/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button = forwardRef((props, ref) => {
  const _a = props, {
    onClick = defaultFunction,
    type = "FILLED",
    className,
    disabled = false,
    children,
    loadingIcon,
    isLoading: forceLoading,
    htmlType
  } = _a, rest = __objRest(_a, [
    "onClick",
    "type",
    "className",
    "disabled",
    "children",
    "loadingIcon",
    "isLoading",
    "htmlType"
  ]);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);
  const clickHandler = async (e) => {
    if (loading || forceLoading)
      return;
    setLoading(forceLoading != null ? forceLoading : true);
    await onClick(e);
    if (!isMounted.current) {
      return;
    }
    setLoading(forceLoading != null ? forceLoading : false);
  };
  useEffect(() => {
    if (typeof forceLoading === "undefined")
      return;
    setLoading(forceLoading);
  }, [forceLoading]);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const renderLoadingIcon = () => {
    var _a2, _b;
    let icon = null;
    if (typeof loadingIcon === "string") {
      icon = /* @__PURE__ */ React.createElement("img", {
        className: "Button__loading__icon",
        src: `${loadingIcon}`,
        alt: "loading"
      });
    } else if (loadingIcon) {
      const LoadingIcon = React.cloneElement(loadingIcon, {
        className: `${(_b = (_a2 = loadingIcon.props) == null ? void 0 : _a2.className) != null ? _b : ""} Button__loading__icon`
      });
      icon = LoadingIcon;
    } else {
      icon = /* @__PURE__ */ React.createElement(LoadingSVG, {
        className: "Button__loading__icon"
      });
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: "Button__loading"
    }, icon);
  };
  const renderChildren = () => {
    if (typeof children === "string") {
      return /* @__PURE__ */ React.createElement("span", {
        className: "Button__wrapper"
      }, children);
    }
    return children;
  };
  return /* @__PURE__ */ React.createElement(ButtonStyled, __spreadProps(__spreadValues({
    className: `Button ${className}`,
    onClick: clickHandler,
    buttonTypes: type,
    disabled,
    isLoading: loading,
    type: htmlType
  }, rest), {
    ref
  }), loading ? renderLoadingIcon() : null, renderChildren());
});
Button.defaultProps = {
  className: "",
  type: "FILLED",
  onClick: defaultFunction,
  disabled: false
};

export { Button as default };
//# sourceMappingURL=bundle.esm.js.map
